import uuid from "react-uuid";

const ENV = process.env.REACT_APP_NODE_ENV;
const BASE_URL_SSD = ENV === 'production' ? process.env.REACT_APP_BASE_URL_SSD : (ENV === 'staging' || ENV === 'development' ) ? process.env.REACT_APP_BASE_URL_SSD_STAGING : 'http://localhost:8080/api';
const BASE_URL_PN = ENV === 'production' ? process.env.REACT_APP_BASE_URL_PN : process.env.REACT_APP_BASE_URL_PN_STAGING;

export const getListsApi = async (listIds) => {

  try {
    if (listIds && listIds.length > 0) {
      console.log('Fetching ' + listIds?.length + ' lists...');
      
      const options = {
        method: 'GET',
        headers: {
          'x-api-key': process.env.REACT_APP_API_KEY,
          'Content-Type': 'application/json',
          'listids': listIds
        },
      };
      
      let result = await fetch(`${BASE_URL_SSD}/lists`, options);
      
      if (result.status === 200) {
        return result.json();
      };
    };
  } catch (error) {
    console.log('Error fetching forecast parameters!');
    console.log(error);
    return false;
  };
};

export const addPetroNinjaListApi = async (user, listId) => {

  try {
    console.log('Fetching Petro Ninja list ' + listId + '...');
    
    const options = {
      method: 'GET',
      mode: 'cors',
      credentials: 'include', 
      headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Content-Type': 'application/json',
      },
    };
    let result = await fetch(`${BASE_URL_PN}/lists/${listId}`, options);

    if (result.status === 200) {
      const list = await result.json();
      const name = list?.name;
      const color = list?.colour;
      const uwiList = [...list?.well_ids];

      const newList = {
        id: uuid(),
        name,
        description: "Created from Petro Ninja List id " + listId,
        color,
        createdBy: user || "worker@ssdynamics.com",
        createdOn: new Date().toLocaleString(),
        lastModified: new Date().toLocaleString(),
        wellUwis: (uwiList?.length > 0 && uwiList) || [],
        typeCurveId: undefined,
        groupWellId: undefined,
        forecastListTab: 0,
        filters: {}
      };
      console.log(newList)
      return newList;
    };

    return null;

  } catch (error) {
    console.log('Error fetching Petro Ninja list!');
    console.log(error);
    return null;
  };
};

export const addListApi = async (list) => {

  try {
    const options = {
      method: 'POST',
      headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({list: list})
    };

    await fetch(`${BASE_URL_SSD}/lists`, options);
    return list;
  } catch (error) {
    console.log('Error fetching forecast parameters!');
    console.log(error);
    return list;
  };
};

export const deleteListApi = async (listId) => {

  try {
    console.log('Deleting list with id', listId);
    const options = {
      method: 'DELETE',
      headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({listId: listId})
    };

    await fetch(`${BASE_URL_SSD}/lists`, options);
    return true;
  } catch (error) {
    console.log('Error fetching forecast parameters!');
    console.log(error);
    return false;
  };
};
